import { render, staticRenderFns } from "./SelectStatusProjeto.vue?vue&type=template&id=46d136ec&scoped=true"
import script from "./SelectStatusProjeto.vue?vue&type=script&lang=js"
export * from "./SelectStatusProjeto.vue?vue&type=script&lang=js"
import style0 from "./SelectStatusProjeto.vue?vue&type=style&index=0&id=46d136ec&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d136ec",
  null
  
)

export default component.exports